<div class="jumbotron">
    <div class="container">
        <div class="home-welcome card shadow-sm mb-4">
            <div class="card-body d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3">
                <div>
                    <h5 class="mb-1">{{ getWelcomeMessage() }}, {{ name || 'Team' }}!</h5>
                    <p class="text-muted mb-0">Today is {{ today | date:'fullDate' }}</p>
                </div>

                <div class="d-flex gap-2">
                    <a class="btn btn-outline-secondary btn-sm" [routerLink]="['/appointments']">Appointments</a>
                    <a class="btn btn-primary btn-sm" [routerLink]="['/patients']">Patients</a>
                </div>
            </div>
        </div>

        <div class="imgbox">
            <img src="../../assets/images/logo.png" class="center-fit">
        </div>
    </div>
</div>